export const POST_CONSTITUTION_REQUEST = 'POST_CONSTITUTION_REQUEST';
export const POST_CONSTITUTION_REQUEST_SUCCESS =
	'POST_CONSTITUTION_REQUEST_SUCCESS';
export const POST_CONSTITUTION_REQUEST_FAILURE =
	'POST_CONSTITUTION_REQUEST_FAILURE';

export const GET_CONSTITUTION_REQUEST = 'GET_CONSTITUTION_REQUEST';
export const GET_CONSTITUTION_REQUEST_SUCCESS =
	'GET_CONSTITUTION_REQUEST_SUCCESS';
export const GET_CONSTITUTION_REQUEST_FAILURE =
	'GET_CONSTITUTION_REQUEST_FAILURE';
export const CLEAR_GET_CONSTITUTION = 'CLEAR_GET_CONSTITUTION';
